module.exports = __webpack_public_path__ + "img/company2.941d6f46.png";